
import dayjs from "dayjs"

export const clearFilterData = {
  TyrCd: null,
  TyrBrand: null,
  TyrSzId: null,
  TyrStsId: null,
  TukId: null,
  TlrId: null,
  IsActv: 1,
}

export const initFilterData = {
  ...clearFilterData,
}

export const initTyreDialogData = {
  TyrCd: "",
  TyrBrand: "",
  TyrModel: "",
  TyrSzId: null,
  PurchPr: 0,
  PurchDte: dayjs().format("YYYY-MM-DD"),
  SupId: null,
  TyrStsId: 1,
  TukId: null,
  TlrId: null,
  TyrPos: "",
  Mileage: 0,
  Dscp: "",
  Rmk: "",
  IsActv: 1,
}

export const initTransactionDialogData = {
  TyrId: null,
  TrnsTyp: "PURCHASE",
  TrnsDte: dayjs().format("YYYY-MM-DD"),
  TukId: null,
  TlrId: null,
  TyrPos: "",
  Mileage: null,
  SupId: null,
  UntPr: 0,
  DocNo: "",
  DocDte: null,
  Dscp: "",
  Rmk: "",
}
